import { oc } from '@orpc/contract';
import { getUserInputSchema, userSchema } from '../schemas/users.schemas.js';
export const getUserContract = oc
    .route({
    method: 'GET',
    path: '/users/{id}',
    tags: ['Users'],
    summary: 'Get one account (ADMIN)',
})
    .input(getUserInputSchema)
    .output(userSchema);
//# sourceMappingURL=get-user.contract.js.map